export const en = {
    profileMenu: {
        terms_condition: 'SpringBig Terms and Condition',
        privacy_policy: 'Springbig QA Privacy Policy'
    }
};
